import React, { useState, useMemo, useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';

function AutoSearch({data, getLabel, setSelected, style}) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelect] = useState('')
    const [open, setOpen] = useState(false)

    const filtered = useMemo(() => {
        if (searchTerm.length < 3) return [];
        
        const lowerSearchTerm = searchTerm.toLowerCase();
        return data.filter(item => item.owner.nom?.toLowerCase().startsWith(lowerSearchTerm) || 
            item.owner.prenom?.toLowerCase().startsWith(lowerSearchTerm) ||
            (item.owner.nom+' '+item.owner.prenom).toLowerCase().startsWith(lowerSearchTerm) ||
            (item.owner.prenom+' '+item.owner.nom).toLowerCase().startsWith(lowerSearchTerm) ||
            item.num?.toLowerCase().startsWith(lowerSearchTerm));
    }, [searchTerm, data]);

    const handleSelect = (event, value) => {
        if (value) {
            setSelected(value)
            setSelect(value)
        }
    };

    return (
        <Autocomplete
        sx={style}
        options={filtered}
        getOptionLabel={(option) => option!==''? getLabel(option):''}
        renderOption={(props, option) => (
            <li key={option._id} {...props} style={{textTransform:'capitalize'}}>
                {getLabel(option)}
            </li>
        )}
        renderInput={(params) => <TextField {...params} label="Rechercher par nom ou N° billet ..." />}
        value={selected}
        onInputChange={(event, newInputValue) => {
            setSearchTerm(newInputValue);
            setOpen(newInputValue.length>2)
        }}
        onChange={handleSelect}
        filterOptions={(x) => x} // Désactive le filtrage interne d'Autocomplete
        noOptionsText={searchTerm.length>1&&"Aucun résultat"}
        open={open}
        onOpen={()=>setOpen(searchTerm.length>1)}
        onClose={()=>setOpen(false)}
        />
    );
}

export default AutoSearch;